<template>
  <section class="search-reviews-wrapper">
    <h2>{{ $t(`${base}.title`, { name }) }}</h2>

    <el-carousel
      type="card"
      height="200px"
      indicator-position="none"
      :autoplay="false"
    >
      <el-carousel-item v-for="review in reviews" :key="review.uuid">
        <div class="review-container">
          <p class="review-summary">“{{ review.message }}”</p>
          <p class="review-user">{{ review._user.profile.fullname }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>

<script>
export default {
  name: 'LadSearchReviewsLegacy',
  props: {
    name: { type: String, required: true },
    reviews: { type: Array, default: () => [], required: false },
  },
  data() {
    return {
      base: 'search.reviews',
    }
  },
}
</script>

<style lang="scss" scoped>
.search-reviews-wrapper {
  margin-top: 20px;

  .el-carousel__item {
    padding: 10px;
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #d3dce6;

    .review-summary {
      font-size: 10px;
      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: justify;
      margin: 0;
    }

    .review-user {
      font-size: 10px;
      text-align: right;
    }
  }
}
</style>
